isCurrentNodeSeries